import { useEffect, useState } from "react";
import { Client } from "../../interfaces/client";
import { useParams } from "react-router-dom";
import { getClient } from "../../services/clientService";
import { ButtonGroup, ToggleButton } from "react-bootstrap";
import ClientInformationHistoryTable from "../../components/admin-components/ClientInformationHistoryTable";
import AdditionalContactsHistoryTable from "../../components/admin-components/AdditionalContactsHistoryTable";
import PositionCodesHistoryTable from "../../components/admin-components/PositionCodesHistoryTable";
import AdditionalFormsHistoryTable from "../../components/admin-components/AdditionalFormsHistoryTable";

const HistoryTables = () => {
  const { clientID } = useParams();
  const [errorMessage, setErrorMessage] = useState("");
  const [client, setClient] = useState<Client | null>(null);
  const [loading, setLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState("Client");

  useEffect(() => {
    const loadPositionCodes = async () => {
      try {
        if (clientID) {
          const numericClientID = parseInt(clientID, 10);
          const client = await getClient(numericClientID);
          setClient(client);
        }
      } catch (error) {
        console.error("Error fetching position codes or services:", error);
        setErrorMessage("Error fetching data.");
      } finally {
        setLoading(false);
      }
    };

    loadPositionCodes();
  }, [clientID]);

  return (
    <div className="content-container">
      <div className="header-container">
        <h1>History Tracking</h1>
        <div className="page-items-container">
          <div className="field-long">
            <label className="field-label">Client Name:</label>
            <div>
              <input
                className="form-control"
                type="text"
                value={client?.clientName || ""}
                disabled
                readOnly
              />
            </div>
          </div>
          <div className="field-long">
            <label className="field-label">Abbreviation:</label>
            <div>
              <input
                className="form-control"
                type="text"
                value={client?.abbreviation}
                disabled
                readOnly
              />
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="loading-divider">
          <div className="loading-bar"></div>
        </div>
      ) : (
        <>
          <div className="divider"></div>
          {errorMessage && <div className="error-message">{errorMessage}</div>}
          <ButtonGroup className="w-100">
            <ToggleButton
              id="client-option"
              type="radio"
              variant={
                selectedOption === "Client" ? "primary" : "outline-primary"
              }
              name="option"
              value="Client"
              checked={selectedOption === "Client"}
              onChange={(e) => setSelectedOption(e.currentTarget.value)}
              className={`w-50 ${
                selectedOption === "Client" ? "toggle-active" : "toggle-outline"
              }`}
            >
              Client Information
            </ToggleButton>
            <ToggleButton
              id="additionalContacts-option"
              type="radio"
              variant={
                selectedOption === "AdditionalContacts"
                  ? "primary"
                  : "outline-primary"
              }
              name="option"
              value="AdditionalContacts"
              checked={selectedOption === "AdditionalContacts"}
              onChange={(e) => setSelectedOption(e.currentTarget.value)}
              className={`w-50 ${
                selectedOption === "AdditionalContacts"
                  ? "toggle-active"
                  : "toggle-outline"
              }`}
            >
              Additional Contacts
            </ToggleButton>
            <ToggleButton
              id="positionCodes-option"
              type="radio"
              variant={
                selectedOption === "PositionCodes"
                  ? "primary"
                  : "outline-primary"
              }
              name="option"
              value="PositionCodes"
              checked={selectedOption === "PositionCodes"}
              onChange={(e) => setSelectedOption(e.currentTarget.value)}
              className={`w-50 ${
                selectedOption === "PositionCodes"
                  ? "toggle-active"
                  : "toggle-outline"
              }`}
            >
              Position Codes
            </ToggleButton>
            <ToggleButton
              id="additionalForms-option"
              type="radio"
              variant={
                selectedOption === "AdditionalForms"
                  ? "primary"
                  : "outline-primary"
              }
              name="option"
              value="AdditionalForms"
              checked={selectedOption === "AdditionalForms"}
              onChange={(e) => setSelectedOption(e.currentTarget.value)}
              className={`w-50 ${
                selectedOption === "AdditionalForms"
                  ? "toggle-active"
                  : "toggle-outline"
              }`}
            >
              Additional Forms
            </ToggleButton>
          </ButtonGroup>
          <div className="mt-3">
            <div>
              {selectedOption === "Client" && client !== null && (
                <ClientInformationHistoryTable
                  client={client}
                ></ClientInformationHistoryTable>
              )}
              {selectedOption === "AdditionalContacts" && client !== null && (
                <AdditionalContactsHistoryTable
                  client={client}
                ></AdditionalContactsHistoryTable>
              )}
              {selectedOption === "PositionCodes" && client !== null && (
                <PositionCodesHistoryTable
                  client={client}
                ></PositionCodesHistoryTable>
              )}
              {selectedOption === "AdditionalForms" && client !== null && (
                <AdditionalFormsHistoryTable
                  client={client}
                ></AdditionalFormsHistoryTable>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default HistoryTables;
